module.exports = __webpack_public_path__ + "img/seller-b3.4c176e13.png";